import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoOptionTwoLines], [xpo-option-two-lines]',
  host: {
    class: 'xpo-Option--twoLines',
  },
})
export class XpoOptionTwoLinesDirective {}
